export default "__VITE_ASSET__IeR0jqdM__"